import { haversineDistance, openInstagramMedia } from '../../../../../util';
import styles from './AddedHotpleItem.module.css';
import LazyLoad from 'react-lazyload';


const AddedHotpleItem = ({hotple, updateHotpleInfo, hotThreshold, devicePosition}) => {
	const whenRightButtonClicked = () => {
		if(hotple.need_verify)
			updateHotpleInfo('showVerifyHotpleModal', hotple);
		else
			updateHotpleInfo('showEditHotpleModal', hotple);
	};

	const { start_date, end_date, mention_count, created_at, has_comment_event, uploaded_at } = hotple;
	let badge = null;

	if (has_comment_event && uploaded_at && (new Date(uploaded_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))) {
		badge = <div className={styles.periodBadge}>댓글 이벤트</div>;
	} else if (start_date && new Date(start_date) > new Date()) {
		badge = <div className={styles.endBadge}>시작예정</div>;
	} else if (end_date && new Date(end_date) < new Date()) {
		badge = <div className={styles.endBadge}>종료됨</div>;
	} else if (end_date && new Date(end_date) < new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)) {
		badge = <div className={styles.periodBadge}>종료임박</div>;
	} else if (mention_count > hotThreshold) {
		badge = <div className={styles.hotBadge}>HOT</div>;
	} else if (new Date(created_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) {
		badge = <div className={styles.newBadge}>NEW</div>;
	}

  	return (
		<div className={styles.nearbyHotpleItem}>
			<div className={styles.imageframe}>
				<div className={styles.padding1}/>
				{hotple.contents_url.length > 0 &&
					<div className={styles.image2frame} onClick={()=>openInstagramMedia(hotple.media_url)}>
						<img className={styles.image1Icon} loading='lazy' alt="" src={hotple.contents_url && hotple.contents_url[0] ? (hotple.contents_url[0].includes("mp4") ? (hotple.preview_url || "images/no_instagram_image.svg") : hotple.contents_url[0]) : (hotple.preview_url || "images/no_instagram_image.svg")} />
						<div className={styles.infoframe}>
							<img className={styles.iconinstagramColor} alt="" src="images/instagram_color.svg" />
							<div className={styles.username}>@{hotple.media_creator}</div>
						</div>
					</div>
				}

				{hotple.contents_url.length>2 ?
					<div className={styles.image2frame} onClick={()=>openInstagramMedia(hotple.media_url)}>
						<img className={styles.image1Icon} loading='lazy' alt="" src={hotple.contents_url[2]} />
						<div className={styles.infoframe2}>
								<img className={styles.iconinstagramColor} alt="" src="images/instagram_color.svg" />
								<div className={styles.username}>@{hotple.media_creator}</div>
						</div>
						<div className={styles.infos}>
							<b className={styles.imagenum}>+{hotple.contents_url.length-2}장</b>
							<div className={styles.div}>
								<span className={styles.txt}>
										<p className={styles.p}>게시글</p>
										<p className={styles.p}>보러가기</p>
								</span>
							</div>
						</div>
					</div>
					:
					<div className={styles.image2frame} onClick={()=>openInstagramMedia(hotple.media_url)}>
						<img className={styles.image1Icon} loading='lazy' alt="" src={hotple.contents_url && hotple.contents_url[1] ? (hotple.contents_url[1].includes("mp4") ? (hotple.preview_url || "images/no_instagram_image.svg") : hotple.contents_url[1]) : (hotple.preview_url || "images/no_instagram_image.svg")} />
						<div className={styles.infoframe2}>
								<img className={styles.iconinstagramColor} alt="" src="images/instagram_color.svg" />
								<div className={styles.username}>@{hotple.media_creator}</div>
						</div>
						<div className={styles.infos}>
							<img className={styles.iconshare} alt="" src="images/share.svg" />
							<div className={styles.div}>
								<span className={styles.txt}>
										<p className={styles.p}>게시글</p>
										<p className={styles.p}>보러가기</p>
								</span>
							</div>
						</div>
					</div>
				}
				<div className={styles.padding1}/>
			</div>

			<div className={styles.analysisParentFrame}>
				<div className={styles.analysisScrollFrame}>
					{hotple.key_features && hotple.key_features.length>0 && 
						<div className={styles.analysisFrame}>
							<div className={styles.padding1}/>
							<div className={styles.positive_text1}>
								★{Math.floor(hotple.average_rating * 100) / 100}점
							</div>
							{hotple.key_features.map(item => (
								<div className={styles.positive_text0}>
									{item}
								</div>
							))}
							<div className={styles.padding1}/>
						</div>
					}

					{hotple.positive_summary && hotple.positive_summary.length>0 && 
						<div className={styles.analysisFrame}>
							<div className={styles.padding1}/>
							<div className={styles.positive_text}>
								긍정 {Math.floor(hotple.positive_ratio*100)}%
							</div>
							{hotple.positive_summary.map(item => (
								<div className={styles.positive_text0}>
									"{item}"
								</div>
							))}
							<div className={styles.padding1}/>
						</div>
					}
				</div>
			</div>

			<div className={styles.detailframe}>
					<div className={styles.detailleft}>
						<div className={styles.title}>
								<div className={styles.hotplename}>{hotple.name}</div>
								{badge && <span className={styles.badgeWrapper}>{badge}</span>}
								{hotple.latitude && hotple.longitude && 
									<div className={styles.ratingframe}>
										<img className={styles.iconfire} alt="star" src="images/my_location.svg" />
										<div className={styles.ratingtext}>{Math.trunc(haversineDistance(devicePosition, {lat:hotple.latitude, long:hotple.longitude}) * 10) / 10}km</div>
									</div>
								}
						</div>
						<div className={styles.tags}>
								<div className={styles.tagplaceDetail}>
									<div className={styles.orange}>{hotple.main_category}</div>
								</div>
								<div className={styles.tagplaceDetail1}>
									<div className={styles.orange}>{hotple.sub_category1} ▸ {hotple.sub_category2}</div>
								</div>
								{hotple.tags.slice(0, 1).map((tag, index) => (
									<div className={styles.tagplaceDetail2} key={index}>
										<div className={styles.orange}>#{tag}</div>
									</div>
								))}
						</div>
						<div className={styles.caption}>{hotple.caption}</div>
						{hotple.comment &&
							<div className={styles.commentframe}>	
									<div className={styles.label}>댓글</div>
									<div className={styles.comment}>
										{hotple.taggedBy!=null &&
											<a className={styles.taggedBy} href={`https://instagram.com/${hotple.taggedBy}`} target="_blank" rel="noopener noreferrer">@{hotple.taggedBy}: </a>
										}
										{hotple.comment.split(/(@[\w\.]+)/g).map((part, index) => {
											if (part.startsWith('@')) {
											// 유저 태그 부분 처리
											const username = part.slice(1); // '@' 제거한 유저 이름
											return (
												<a
												key={index}
												className={styles.commentUser}
												href={`https://instagram.com/${username}`}
												target="_blank"
												rel="noopener noreferrer"
												>
												{part}
												</a>
											);
											} else {
											// 일반 텍스트 처리
											return (
												<span key={index} className={styles.span}>
												{part}
												</span>
											);
											}
										})}
									</div>
							</div>
						}
						{hotple.has_period &&
							<div className={styles.commentframe}>
									<div className={styles.label}>기간</div>
									<div className={styles.period}>{hotple.start_date && hotple.start_date.replaceAll('-','/')} ~ {hotple.end_date && hotple.end_date.replaceAll('-','/')}</div>
							</div>
						}
					</div>
					<div className={styles.detailrightbutton} onClick={(event)=>{event.stopPropagation();whenRightButtonClicked();}}>
						{hotple.need_verify ?
							<img className={styles.iconlikeActive} alt="" src= "images/update.svg" />
							:
							<img className={styles.iconlikeOutlined} alt="" src= "images/pen.svg" />
						}
						<div className={hotple.need_verify ? styles.is_pick : styles.not_pick}> {hotple.need_verify ? "검토 필요" : "정보 수정"} </div>
					</div>
			</div>
		</div>
	);
};

export default AddedHotpleItem;
